import React from 'react';
import classes from './TableHeader.module.css';
import { ReportTableColumn, RowAction } from './interfaces';
import arrowDown from '../../../../assets/icons/arrow-down.svg';

const TableHeader: React.FC<{
  columns: ReportTableColumn[];
  actions: RowAction[];
}> = ({ columns, actions }) => {
  return (
    <thead>
      <tr>
        {columns.map((col, index) => (
          <th
            key={index}
            className={classes.reportTableHead}
            onClick={col.onSort ? col.onSort : undefined}
          >
            <div className={classes.headerContent}>
              {col.name}
              {col.onSort && (
                <img
                  src={arrowDown}
                  style={{
                    transform: col.sortOrder === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)',
                  }}
                />
              )}
            </div>
          </th>
        ))}
        {actions.length > 0 && <th className={classes.reportTableHead} />}
      </tr>
    </thead>
  );
};

export { TableHeader };
